<!--Start Header Container-->
<ng-container *ngIf="selectedsubmenu !== 'materialpassport'">
    <div class="container header">
        <div class="row_container">
            <div class="col-12">
                <div class="logo">
                    <i class="gpr-logo"></i>
                </div>
                <div class="logo-text">{{'PRINT_PAGE.MATERIAL' | translate}}</div>
            </div>
        </div>
    </div>
</ng-container>
<!--End Header Container-->
<!--Start Content Container-->
<ng-container *ngIf="printData && selectedsubmenu === 'materialpassport'">
    <app-print-page-landscape *ngIf="printData"
                              [selectedsubmenu]="selectedsubmenu"
                              [printData]="printData"
                              [calculationName]="calculationName"
                              [projectCharacteristics]="projectCharacteristics"
                              [isProjectPhaseUIEnabled]="isProjectPhaseUIEnabled"
                              [isExistingBuildingCal]="isExistingBuildingCal"
                              [elementResultTitle]="elementResultTitle"
                              [calculationResults]="calculationResults"
                              [calculationResultsAfter]="calculationResultsAfter"
                              [selectedDataSet]="selectedDataSet"
                              [mpgResultTitlePerMainElementTitle]="mpgResultTitlePerMainElementTitle"
                              [envirnmentalCategoryTitle]="envirnmentalCategoryTitle"
                              [environmentEffects]="environmentEffects"
                              [environmentEffectsAfter]="environmentEffectsAfter"
                              [mpgResultTitle]="mpgResultTitle"
                              [chartOption]="chartOption"
                              [currentMainElements]="currentMainElements"
                              [afterMainElements]="afterMainElements"
                              [codes]="codes"
                              [tableColumns]="tableColumns"
                              [qciResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.qciResults"
                              [hnnResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.hnnResults"
                              [csrdResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.csrdResults"
                              [wlcResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.wlcResults"
                              [mpg]="nmdCalculationResponseDto_ForExtraIndicator?.mpg"
                              [parisProofIndicator]="nmdCalculationResponseDto_ForExtraIndicator?.parisProofIndicator"
                              [totalUsedProducts]="nmdCalculationResponseDto_ForExtraIndicator?.totalUsedProducts"
                              [constructionStoredCarbon]="nmdCalculationResponseDto_ForExtraIndicator?.constructionStoredCarbon"
                              [isShowIndicatorPage]="isShowIndicatorPage"
    >
    </app-print-page-landscape>
</ng-container>

<div class="container content print_container" *ngIf="printData">
    <ng-container *ngIf="selectedsubmenu !== 'materialpassport'">
        <div class="row_container titles">
            <div class="col-12">
                <div class="grey">
                    {{'PRINT_PAGE.REPORT' | translate}}
                </div>

                <div *ngIf="selectedsubmenu=='all' || selectedsubmenu=='mpg'; else otherText">
                    {{ 'PRINT_PAGE.ENV_PERFORMANCE_CALCULATION' | translate }}
                </div>
                <ng-template #otherText>
                    {{ 'PRINT_PAGE.TITLE_FOR_EXTRAINDICATORS' | translate }}
                </ng-template>

                <div id="calc-name">
                    {{'PRINT_PAGE.CALCULATION_NAME' | translate}}: {{calculationName}}
                </div>
            </div>
        </div>

        <div class="row_container projectkenmerken">
            <div class="col-6 projectinfo">
                <div class="sbheader">
                    {{'PRINT_PAGE.PROJECT_FEATURES' | translate}}
                </div>

                <div class="row">
                    <div class="col endline">
                        <h6>{{'PROJECT_CHARACTERISTICS.PROJECT_LOCATION' | translate}}</h6>
                        <div class="lab">{{'PRINT_PAGE.ADDRESS' | translate}}</div>
                        <div class="fld">
                            {{projectCharacteristics.streetName}} {{projectCharacteristics.houseNumber}}
                            {{projectCharacteristics.houseLetter}}
                        </div>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.POSTAL_CODE' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.postalCode}}</div>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.TOWN' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.town}}</div>
                    </div>

                    <div class="col endline">
                        <h6>{{'PROJECT_CHARACTERISTICS.PROJECT_ORGANISATION' | translate}}</h6>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.CLIENT' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.client}}</div>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.ARCHITECT' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.architect}}</div>
                        <div class="lab">{{'PRINT_PAGE.DATE_OF_PERMIT' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.buildingPermitDate | date : "dd MMMM yyyy"}}</div>
                    </div>

                    <div class="col" *ngIf="isProjectPhaseUIEnabled">
                        <h6>{{'PROJECT_CHARACTERISTICS.PROJECT_STATUS' | translate}}</h6>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.PHASE' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.phaseId | phaseLabel}}</div>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.STATUS' | translate}}</div>
                        <div class="fld">{{projectCharacteristics.statusId === 0 ? ('PROJECT_CHARACTERISTICS.STATUS_DEFAULT' | translate) : ('PROJECT_CHARACTERISTICS.STATUS_FINAL' | translate)}}</div>
                        <div class="lab">{{'PROJECT_CHARACTERISTICS.PURPOSE' | translate}}</div>
                        <div class="fld" [innerHTML]="projectCharacteristics.purposeValue | purposeLabel"></div>
                    </div>
                </div>
            </div>

            <div class="col-6 projectinfo">
                <!-- New Building characteristics inputs -->
                <ng-container *ngIf="!isExistingBuildingCal">
                    <div class="sbheader">
                        {{'HEADER.BUILDING_CHARACTERISTICS' | translate}}
                    </div>
                    <div class="row" *ngFor="let mainCharacteristic of printData.mainCharacteristics">
                        <div class="col" *ngIf="mainCharacteristic.parameters">
                            <h6>{{'BUILDING_CHARACTERISTICS.BUILDING' | translate}}</h6>
                            <div *ngIf="mainCharacteristic.parameters">
                                <div *ngFor="let parameter of getFilteredParameters(mainCharacteristic.parameters)">
                                    <div class="lab">{{parameter.name}}</div>
                                    <div class="fld">
                                        {{parameter.value}}
                                        <span *ngIf="parameter.name === 'Bruto Vloeroppervlak (BVO)'">m<sup>2</sup></span>
                                        <span *ngIf="parameter.name === 'Gebouwlevensduur'">jaar</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Existing Building characteristics inputs -->
                <ng-container *ngIf="isExistingBuildingCal">
                    <div class="sbheader">
                        {{'BUILDING_CHARACTERISTICS.EXISTING_BUILD' | translate}}
                    </div>
                    <div class="row" *ngFor="let existingBuilding of printData.mainCharacteristics">
                        <!-- <h6>{{existingBuilding.elementName | titlecase}}</h6> -->

                        <div class="col" *ngFor="let buildingElement of existingBuilding.existingBuildingElements;let i = index">
                            <h6>{{buildingElement.elementName | titlecase}}</h6>

                            <div *ngFor="let parameter of buildingElement.parameters">
                                <div>
                                    <div class="lab">{{parameter.name}}</div>
                                    <div class="fld">
                                        <span [id]="parameter.name + i">{{parameter.value}}</span>
                                        <span *ngIf="parameter.name === 'Bruto Vloeroppervlak (BVO)'">m<sup>2</sup></span>
                                        <span *ngIf="parameter.name === 'Gebouwlevensduur'">
                                            {{
'BUILDING_CHARACTERISTICS.YEAR' |
                    translate
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Huidig LifeSpans -->
                            <div class="huidig grey-200" *ngIf="buildingElement.elementName == 'Huidig'">
                                <div class="mb-2">
                                    <span>{{'BUILDING_CHARACTERISTICS.LIFESPAN' | translate}}</span><br />
                                    <span class="jaar">{{levensduurHuidig}} {{'BUILDING_CHARACTERISTICS.YEAR' | translate}}</span>
                                </div>
                                <div>
                                    <span>{{'BUILDING_CHARACTERISTICS.REMAINING_LIFESPAN' | translate}}</span><br />
                                    <span class="jaar">{{resterendLevensduurHuidig}} {{'BUILDING_CHARACTERISTICS.YEAR' | translate}}</span>
                                </div>
                            </div>

                            <!-- Ingreep LifeSpans -->
                            <div class="ingreep grey-200" *ngIf="buildingElement.elementName == 'Ingreep'">
                                <div class="mb-2">
                                    <span>{{'BUILDING_CHARACTERISTICS.LIFESPAN' | translate}}</span><br />
                                    <span class="jaar">{{levensduurIngreep}} {{'BUILDING_CHARACTERISTICS.YEAR' | translate}}</span>
                                </div>
                                <div>
                                    <span>{{'BUILDING_CHARACTERISTICS.REMAINING_LIFESPAN' | translate}}</span><br />
                                    <span class="jaar">{{resterendLevensduurIngreep}} {{'BUILDING_CHARACTERISTICS.YEAR' | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!--Start Accountability Container-->
        <div class="row_container accountability">
            <div class="col-12">
                <h6><strong>{{'PRINT_PAGE.ACCOUNTABILITY' | translate}}</strong></h6>
                <small>
                    Deze berekening is gemaakt met GPR Materiaal versie {{printData.materialsAppVersionNumber || 0}}.
                    Er is voor de berekening gebruik gemaakt van de productendatabase met peildatum
                    {{
printData.lastNmdProductUpdateDate
        | date : "dd MMMM yyyy"
                    }}
                    van de nationale milieudatabase versie 3.0
                </small>
            </div>
        </div>
        <!--End Accountability Container-->
        <!--New page (page2)-->
        <app-print-mpg *ngIf="selectedsubmenu=='all' || selectedsubmenu=='mpg'"
                       [mpgResultTitle]="mpgResultTitle"
                       [calculationResults]="calculationResults"
                       [calculationResultsAfter]="calculationResultsAfter"
                       [isExistingBuildingCal]="isExistingBuildingCal"
                       [selectedDataSet]="selectedDataSet"
                       [mpgResultTitlePerMainElementTitle]="mpgResultTitlePerMainElementTitle"
                       [printData]="printData"
                       [envirnmentalCategoryTitle]="envirnmentalCategoryTitle"
                       [environmentEffects]="environmentEffects"
                       [environmentEffectsAfter]="environmentEffectsAfter"
                       [chartOption]="chartOption"
                       [afterMainElements]="afterMainElements"
                       [currentMainElements]="currentMainElements"
                       [codes]="codes"
                       [tableColumns]="tableColumns"></app-print-mpg>


        <!-- Extra Indicator Pages-->

        <app-print-extra-indicator *ngIf="(selectedsubmenu=='all' || selectedsubmenu=='extraindicators') &&
                                     (!isExistingBuildingCal && isShowIndicatorPage)"
                                   [csrdResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.csrdResults"
                                   [qciResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.qciResults"
                                   [hnnResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.hnnResults"
                                   [wlcResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.wlcResults"
                                   [mpg]="nmdCalculationResponseDto_ForExtraIndicator?.mpg"
                                   [parisProofIndicator]="nmdCalculationResponseDto_ForExtraIndicator?.parisProofIndicator"
                                   [selectedDataSet]="selectedDataSet"
                                   [totalUsedProducts]="nmdCalculationResponseDto_ForExtraIndicator?.totalUsedProducts"
                                   [constructionStoredCarbon]="nmdCalculationResponseDto_ForExtraIndicator?.constructionStoredCarbon"></app-print-extra-indicator>

        <!-- End Extra Indicator Pages-->

        <app-print-mpg-elements *ngIf="selectedsubmenu=='all' || selectedsubmenu=='mpg'"
                                [elementResultTitle]="elementResultTitle"
                                [calculationResults]="calculationResults"
                                [calculationResultsAfter]="calculationResultsAfter"
                                [isExistingBuildingCal]="isExistingBuildingCal"
                                [selectedDataSet]="selectedDataSet"
                                [mpgResultTitlePerMainElementTitle]="mpgResultTitlePerMainElementTitle"
                                [printData]="printData"
                                [envirnmentalCategoryTitle]="envirnmentalCategoryTitle"
                                [environmentEffects]="environmentEffects"
                                [environmentEffectsAfter]="environmentEffectsAfter"></app-print-mpg-elements>

    </ng-container>
</div>
<!--End Content Container-->
<!--Start Footer Container-->
<ng-container *ngIf="selectedsubmenu !== 'materialpassport'">
    <div class="container footer">
        <div class="row_container">
            <div class="col-12">
                <div class="row justify-content-between">
                    <div class="col">
                        <div class="logo">
                            <i class="gpr-logo"></i>
                        </div>
                        <div class="logo-text">{{'PRINT_PAGE.MATERIAL' | translate}}</div>
                    </div>

                    <!--<div class="col text-right pnum">1</div>-->
                </div>
            </div>
        </div>

        <div class="row_container">
            <div class="col-12">
                <img src="../../assets/img/gpr_materiaal-footer.png" class="img-fluid" />
            </div>
        </div>
    </div>
</ng-container>
<!--End Footer Container-->
